import _ from 'lodash';
import moment from 'moment';
import { CONTACT_CHANNEL_TYPES } from '../recruiter/constants/contactTypes';

const ICONS_BY_CHANNEL_TYPE = {
    [CONTACT_CHANNEL_TYPES.EMAIL]: 'email',
    [CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE]: 'linked_in',
    [CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL]: 'linked_in_inmail',
    [CONTACT_CHANNEL_TYPES.TALK]: 'phone',
    [CONTACT_CHANNEL_TYPES.FACEBOOK]: 'facebook',
};

export const CONTACT_CHANNEL_LABELS = {
    [CONTACT_CHANNEL_TYPES.EMAIL]: 'EMAIL_CHANNEL',
    [CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE]: 'LINKEDIN',
    [CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL]: 'IN_MAIL_CHANNEL',
    [CONTACT_CHANNEL_TYPES.TALK]: 'PHONE_CHANNEL',
    [CONTACT_CHANNEL_TYPES.FACEBOOK]: 'FACEBOOK_CHANNEL',
};

export const isChannelContactConfirmed = (channel) => {
    const result = (channel.contactDataItems || []).some(channelContactDataItem => !!_.get(channelContactDataItem, 'confirmedDate', null));

    return result;
};

export const checkIsEmptyChannel = channel => _.get(channel, 'contactDataItems.length', 0) === 0;

export const getFormattedContactChannelDate = date => moment(new Date(date)).format('M/D/YYYY HH:mm');

export const getChannelIcon = (channelName, isConfirmed) => {
    let iconFileName = ICONS_BY_CHANNEL_TYPE[channelName];
    iconFileName = isConfirmed ? `${iconFileName}_confirmed` : iconFileName;

    return `/assets/img/contact-channel-icons/${iconFileName}.svg`;
};

export const sortChannelContactItemsByDate = channelContactItems =>
    _.orderBy(channelContactItems, ['contactedDate', 'confirmedDate'], 'desc');

export const isEmployerContactCandidate = (contactChannel) => {
    const channelData = _.get(contactChannel, 'channelData', {});
    const allChannelDataItems = Object.keys(channelData).reduce((result, key) => {
        const items = channelData[key];

        result.push(...items);

        return result;
    }, []);

    return (allChannelDataItems || []).some(item => _.get(item, 'contactedByInfo.role') === 'EM');
};
